import { svg } from "lit";
const icon = svg `<path d="M9.10394 11.5212L13.4116 7.2135L12.5623 6.385L9.10394 9.84333L7.41644 8.15583L6.55908 8.99236L9.10394 11.5212ZM1.32031 16.3593V15.276H18.6792V16.3593H1.32031ZM2.41644 14.276V3.60938H17.5831V14.276H2.41644ZM3.49977 13.1927H16.4998V4.69267H3.49977V13.1927Z" fill="currentColor"/>`;
export default icon;
